function load(component) {
  return () => import(`@/components/comum/${component}`)
}

function loadC(component) {
  return () => import(`@/components/${component}`)
}

const MctLogarPortal = () => import('@/components/seguranca/MctLogarPortal')

export default [
  { path: '/portal/logar', name: 'PortalLogar', component: MctLogarPortal },
  { path: '/portal/matriculas', name: 'PortalMatriculas', component: loadC('modulos/portal/Matriculas') },
  { path: '/portal/menu', name: 'PortalMenu', component: loadC('modulos/portal/MenuPortal') },

  { path: '/portal/notas/:entidade/:escola/:ano_letivo/:turma/:horario', name: 'PortalNotas', component: loadC('modulos/portal/NotasFaltas') },
  { path: '/portal/boletim/:entidade/:escola/:ano_letivo/:turma/:aluno', name: 'PortalBoletim', component: loadC('modulos/portal/Boletim') },
  { path: '/portal/horarios/:entidade/:escola/:ano_letivo/:turma/:horario', name: 'PortalHorarios', component: loadC('modulos/portal/Horarios') },
  { path: '/portal/calendario/:entidade/:escola/:ano_letivo/:turma', name: 'PortalCalendario', component: loadC('modulos/portal/Calendario') },
  { path: '/portal/conteudo/:entidade/:escola/:ano_letivo/:turma', name: 'PortalConteudo', component: loadC('modulos/portal/Conteudo') },

  { path: '/portal/dados', name: 'PortalDadosPessoais', component: loadC('modulos/portal/DadosPessoais') },

  //   {
  //     path: '/portal',
  //     name: 'PortalLogar',
  //     redirect: '/portal/logar',
  //     component: {
  //       render(c) {
  //         return c('router-view')
  //       },
  //     },
  //     children: [
  //       //   { path: 'logar', name: 'Logar', component: MctLogarPortal, meta: { breadcrumb: [{ text: 'Logar' }] } },
  //       { path: 'matriculas', name: 'PortalMatriculas', component: loadC('modulos/portal/Matriculas'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Matriculas' }] } },

  //       { path: 'notas/:entidade/:escola/:ano_letivo/:turma/:horario', name: 'PortalNotas', component: loadC('modulos/portal/NotasFaltas'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Notas' }] } },

  //       { path: 'boletim/:entidade/:escola/:ano_letivo/:turma/:aluno', name: 'PortalBoletim', component: loadC('modulos/portal/Boletim'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Boletim' }] } },

  //       { path: 'horarios/:entidade/:escola/:ano_letivo/:turma/:horario', name: 'PortalHorarios', component: loadC('modulos/portal/Horarios'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Horarios' }] } },

  //       { path: 'calendario/:entidade/:escola/:ano_letivo/:turma', name: 'PortalCalendario', component: loadC('modulos/portal/Calendario'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Horarios' }] } },

  //       { path: 'conteudo/:entidade/:escola/:ano_letivo/:turma', name: 'PortalConteudo', component: loadC('modulos/portal/Conteudo'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Conteudo' }] } },

  //       { path: 'dados', name: 'PortalDadosPessoais', component: loadC('modulos/portal/DadosPessoais'), meta: { breadcrumb: [{ text: 'Portal', to: '/portal' }, { text: 'Dados Pessoais' }] } },
  //     ],
  //   },
]
